import React, { createContext, useContext } from 'react';

const ToneContext = createContext('light');

const TONE = {
  light: {
    head: 'text-slate-500 border-slate-200',
    headBg: 'bg-slate-50',
    divide: 'divide-slate-100',
    row: 'hover:bg-slate-50',
    cell: 'text-slate-700',
  },
  dark: {
    head: 'text-slate-500 border-slate-800',
    headBg: 'bg-slate-900',
    divide: 'divide-slate-800',
    row: 'hover:bg-slate-800/40',
    cell: 'text-slate-300',
  },
};

// Single table shell — replaces the hand-rolled <table> markup repeated
// (with small drifts) across every data-table page in the app.
export const Table = ({ tone = 'light', className = '', children }) => (
  <ToneContext.Provider value={tone}>
    <div className="overflow-x-auto">
      <table className={['w-full text-sm', className].join(' ')}>{children}</table>
    </div>
  </ToneContext.Provider>
);

export const THead = ({ children }) => {
  const tone = useContext(ToneContext);
  return <thead className={TONE[tone].headBg}>{children}</thead>;
};

export const TBody = ({ children }) => {
  const tone = useContext(ToneContext);
  return <tbody className={['divide-y', TONE[tone].divide].join(' ')}>{children}</tbody>;
};

export const TR = ({ className = '', children, ...rest }) => {
  const tone = useContext(ToneContext);
  return (
    <tr className={['transition-colors', TONE[tone].row, className].join(' ')} {...rest}>
      {children}
    </tr>
  );
};

export const TH = ({ className = '', children, ...rest }) => {
  const tone = useContext(ToneContext);
  return (
    <th
      className={['text-left text-xs font-medium uppercase tracking-wider px-4 py-3 border-b', TONE[tone].head, className].join(' ')}
      {...rest}
    >
      {children}
    </th>
  );
};

export const TD = ({ className = '', children, ...rest }) => {
  const tone = useContext(ToneContext);
  return (
    <td className={['px-4 py-3 align-middle', TONE[tone].cell, className].join(' ')} {...rest}>
      {children}
    </td>
  );
};
